import React from "react";
import { useTranslation } from "react-i18next";
import BackArrowButton from "../../../../parts/back-arrow-button";
import SettingsNav from "../../../../parts/settings-nav";
import submit from "submit-form";
import { SettingsBackHandler } from "../../../coaching-portal/settings/components/SettingsBackHandler";

export const CreateOrganizationComponent = ({ locals }) => {
  const { t } = useTranslation("dashboard");
  const {
    organizationRoles = [],
    organizationPermissions = [],
    activeUser,
  } = locals;

  const userIsPush = Boolean(activeUser.pushAccountInfo);
  const userIsPress = Boolean(activeUser.pressAccountInfo);

  //filtering the permissions to show if the user is push or press
  const filteredPermissions = organizationPermissions.filter(
    ({ permission }) => {
      if (
        (permission !== "PUSH" && permission !== "PRESS") ||
        (permission === "PUSH" && userIsPush) ||
        (permission === "PRESS" && userIsPress)
      ) {
        return true;
      }
      return false;
    }
  );

  /**
   * Function to convert the user to an organization
   * @param {*} e
   */
  const createOrganization = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const ownerRoleId = organizationRoles.find(
      ({ role }) => role === "Owner"
    )._id;

    const permissionIds = filteredPermissions.map(
      (permission) => permission._id
    );

    const body = {
      ownerRoleId,
      permissionIds,
    };

    if (
      process.browser &&
      confirm(t("manageCoaches.createOrganizationConfirm"))
    ) {
      submit(`/actions/organizations/save`, {
        method: "POST",
        body,
      });
    }
  };

  return (
    <main className="settings create-organization">
      <SettingsNav classNames="mobile-hidden" />

      <section>
        <SettingsBackHandler title={t("manageCoaches.title")} />
        <h3 className="force-mobile-hidden">{t("manageCoaches.title")}</h3>
        <article>
          <div>
            <p className="s1">{t("manageCoaches.turnAccountIntoOrganization")}</p>
            <p className="p4">
              {t("manageCoaches.createOrganizationDescription")}
            </p>
          </div>
          <button data-button-type="primary" onClick={createOrganization}>
            {t("manageCoaches.createOrganization")}
          </button>
        </article>
      </section>
    </main>
  );
};
